<template>
  <v-flex>
    <v-card-title>
      <v-chip
        v-if="created"
        class="my-1"
      >
        Created: {{ formatTimestamp(created) }}
      </v-chip>
      <v-chip
        v-if="updated"
        class="my-1"
      >
        Updated: {{ formatTimestamp(updated) }}
      </v-chip>
      <v-spacer />
      <v-text-field
        v-model="search"
        style="min-width: 220px"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="auditTrailData"
      hide-default-footer
      :search="search"
      :custom-filter="searchTable"
      :items-per-page="-1"
    >
      <template v-slot:item="props">
        <tr>
          <td>
            <div>{{ props.item.fullName }}</div>
            <div>({{ props.item.username.match(/^[a-z]4tea$/) ? 'foretees support' : props.item.username }})</div>
          </td>
          <td>
            <div>{{ props.item.recordTypeLabel }} #{{ props.item.recordId || 'd'+props.item.deletedId }}</div>
            <div>{{ loadName(props.item) }}</div>
          </td>
          <td>{{ props.item.action }}</td>
          <td>
            <ul>
              <li
                v-for="(change, i) in props.item.recordChanges"
                :key="i"
              >
                {{ change.description }}
              </li>
            </ul>
          </td>
          <td>{{ formatTimestamp(props.item.created) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
export default {
  name: 'AuditTrail',
  components: {
  },

  props: {
    recordType: String,
    id: [String, Number],
    created: String,
    updated: String,
    nameNotFound: {
      type: Function,
      default (item) {
        return null
      }
    },
    loadName: {
      type: Function,
      default (item) {
        if (item.recordPost) {
          return item.recordPost.name || this.nameNotFound(item)
        } else if (item.recordPre) {
          return item.recordPre.name || this.nameNotFound(item)
        }
        return this.nameNotFound(item)
      }
    },
    children: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      search: '',
      headers: [
        {
          text: 'User',
          align: 'left',
          sortable: false,
          value: 'username'
        },
        {
          text: 'Record',
          align: 'left',
          sortable: false,
          value: 'recordTypeLabel'
        },
        {
          text: 'Action',
          align: 'left',
          sortable: false,
          value: 'action'
        },
        {
          text: 'Change',
          align: 'left',
          sortable: false,
          value: 'recordChanges'
        },
        {
          text: 'When',
          align: 'left',
          sortable: false,
          value: 'created'
        }
      ],
      loaded: false,
      loadedAuditTrail: false,
      auditTrailData: [],
      loading: false,
      errors: []
    }
  },
  mounted () {
    this.loadAuditTrail()
  },
  methods: {
    formatTimestamp (timestamp) {
      // Convert zoned date/time to club's local time, and format for display
      return this.$ftAPI().clubMoment(timestamp).format('MMM, D YYYY h:mm:ss A')
    },
    searchTable (val, search) {
      if (search === null || search === undefined || search === '') {
        return true
      }
      if (Array.isArray(val)) {
        for (var i in val) {
          if (val[i].change) {
            return this.searchTable(val[i].description, search)
          }
        }
      }
      return val !== null &&
            ['undefined', 'boolean'].indexOf(typeof val) === -1 &&
            val.toString().toLowerCase().indexOf(search) !== -1
    },
    loadAuditTrail () {
      if (this.id) {
        this.$ftAPI().get(
          {
            command: 'audit',
            load: this.auditTrailData,
            loading: this.loading,
            params: {
              id: this.id,
              record_type: this.recordType,
              children: this.children,
              include_fields: ['recordChanges', 'recordTypeLabel', 'fullName']
            }
          }
        )
      }
    }
  }
}
</script>
